const routes = {
  home: '/',
  login: '/login',
  register: '/register',
  orders: '/orders',
  mailbox: '/mailbox',
  deleted: '/deleted',
  settings: '/settings',
  singleEmail: '/singleEmail',
};

export default routes;
